import React from 'react'

import { Box, Typography } from "@mui/material"


export default function seatsColumn() {

	return {
		name: 'seats',
		label: 'N˚ of seats',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{value ?? "Any"}</Typography>
			</Box>,
		}
	}
}